import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { NotificationProvider } from './components/base/Alert';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <NotificationProvider>
        <App />
    </NotificationProvider>,
);
